var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "upload-center",
      class: { "upload-successful-page": !_vm.showFilesUploadForm }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFilesUploadForm,
              expression: "showFilesUploadForm"
            }
          ],
          staticClass: "acc-page-holder"
        },
        [
          _c("h1", [_vm._v("Documents Upload")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "acc-upload-center" },
            [
              _c("p", { staticClass: "disclaimer" }, [
                _vm._v(
                  "All uploaded documents are stored securely. Please review our Terms of Use and Privacy Policy"
                )
              ]),
              _vm._v(" "),
              _c("FilesUploadForm", {
                attrs: { numberOfFiles: _vm.documentsUploadLimit },
                on: {
                  "files-upload-successful": function($event) {
                    _vm.showFilesUploadForm = false
                  },
                  "all-files-uploaded": _vm.onAllFilesUploaded
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("UploadSuccessfulScreen", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showFilesUploadForm,
            expression: "!showFilesUploadForm"
          }
        ],
        attrs: { allFilesUploaded: _vm.allFilesUploaded },
        on: {
          "add-more-files": function($event) {
            _vm.showFilesUploadForm = true
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-568204a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-568204a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/UploadCenter/UploadCenter.vue
// module id = null
// module chunks = 